import React, { useState } from "react";
import { Fade } from "react-awesome-reveal";
import { useLocation, Navigate } from "react-router-dom";
// import { Plus, Minus } from "lucide-react";

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const location = useLocation();
  const moveToSection = (id) => {
    if (location.pathname !== "/") {
      // Go to home page *with state*
      Navigate("/", { state: { scrollTo: id } });
    }
    //  else if (location.pathname !== "/about") {
    //   navigate("/about", { state: { scrollTo: id } });
    // }
    else {
      // Already on home → scroll immediately
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  const faqs = [
    {
      question: "Do you provide cars for IT and corporate companies?",
      answer:
        "Yes, Carzen Logistics specializes in providing chauffeur-driven cars for BPO’s/IT/Corporate companies. We offer flexible daily, monthly, and yearly plans tailored to meet your team’s mobility requirements.",
    },
    {
      question: "What types of vehicles are available?",
      answer:
        "Our fleet includes sedans, SUVs, luxury cars, mpv's and big size vehicles — perfect for airport transfers, employee commuting, client visits, and corporate tours.",
    },
    {
      question: "Are your vehicles and drivers available 24/7?",
      answer:
        "Yes, our services operate round the clock. Whether it’s an early morning pickup or a late-night airport drop, we ensure timely service and support.",
    },
    {
      question: "How do you ensure safety and professionalism?",
      answer:
        "All our chauffeurs are background-verified, uniformed, and trained in corporate etiquette. Every vehicle is GPS-enabled and sanitized regularly for complete safety.",
    },
    {
      question: "Do you offer airport transfer services?",
      answer:
        "Absolutely. We provide seamless airport transfers with professional chauffeurs, real-time tracking, and on-time arrival guarantees.",
    },
    {
      question: "Can we get long-term rental contracts?",
      answer:
        "Yes, we offer dedicated long-term and contract-based solutions for IT and corporate clients, complete with monthly billing, priority support, and dedicated account management.",
    },
  ];

  return (
    <section className="max-w-8xl  md:px-[50px] lg:px-[120px] py-16  mx-4">
      <Fade direction="up" triggerOnce ascade damping={0.2}>
        {/* Header */}
        <div className="text-center max-w-7xl mx-auto mb-10">
          <p className="text-sm text-gray-500 mb-2 md:mb-0 md:h-[26px]">FAQs</p>
          <h2 className="text-2xl md:text-4xl font-bold content-center md:h-[62px] text-gray-900 mb-4 md:mb-6">
            Corporate Travel Questions
          </h2>
          <p className="text-gray-600 text-sm font-medium md:text-[18px] leading-relaxed">
            Everything you need to know about our rental plans, services, and
            corporate mobility solutions.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="w-full  space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-[#CCA065]  text-white rounded-lg overflow-hidden shadow-md transition-all"
            >
              <button
                className="w-full flex justify-between items-center px-6 py-4 text-left font-semibold text-base md:text-[18px] focus:outline-none"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span>{faq.question}</span>
                <span className="text-center h-[14px] w-[14px]">
                  {" "}
                  {
                    openIndex === index
                      ? "-"
                      : // <Minus className="w-5 h-5 text-white" />
                        "+"
                    // <Plus className="w-5 h-5 text-white" />
                  }
                </span>
              </button>

              {openIndex === index && (
                <div className="px-8 pb-4 text-sm md:text-[18px] text-white/90 animate-fadeIn">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Contact Section */}
        <div className=" flex  justify-between items-center  text-start mt-4 md:mt-10 md:h-[90px]">
          <div>
            <h3 className=" md:text-4xl font-semibold text-gray-900 mb-2">
              Still have questions?
            </h3>
            <p className="text-[16px] md:text-[18px] mb-6">
              We're here to help!
            </p>
          </div>
          <button
            onClick={() => moveToSection("contact us")}
            className="bg-black text-center md:w-[132px] h-[40px] md:h-[50px] text-white px-6 py-2 rounded-full font-medium hover:bg-gray-800 transition"
          >
            Contact
          </button>
        </div>
      </Fade>
    </section>
  );
};

export default Faq;
